import React, { Component } from 'react';
import './DropDownSelectMany.css';
import FontIcon from '../fontIcon/FontIcon';
import Validation from '../validation/Validation';
import models from '../../model/models';
import mainAPI from '../../api/MainAPI';
import Input from '../../inputs/input/Input';
import fuzzysort from 'fuzzysort';
import objUtils from '../../utils/objUtils';
import CheckBox from '../../inputs/checkBox/CheckBox';
import Label from '../label/Label';
import Divider from '../divider/Divider';
import PrimaryButton from '../primaryButton/PrimaryButton';

export default class DropDownSelectMany extends Component {
	constructor(props) {
		super(props);
		let value = this._defaultValue();
		let search = '';
		if (this.props.options) search = this.getSearch(this.props.options[value], this.props.displayFields, {});
		this.state = {
			options: this.props.options,
			value,
			search,
			valid: true,
			open: false,
			values: {}
		};
		if (this.props.model) {
			this.state.options = models[this.props.model].objs();
		}
		this.state.options = this._formatOptions(this.state.options);
		this.state.filteredOptions = this.state.options;
	}

	componentDidMount = async () => {
		document.addEventListener('mousedown', this._checkForOutsideClick, false);
		document.addEventListener('touchstart', this._checkForOutsideClick, false);
		if (!this.props.src && !this.props.endpoint && !this.props.model) return;
		await this._setOptions();
		if (this.props.subscribeTo) {
			this.subId = models[this.props.subscribeTo].onChange(this._setOptions);
		}
	};

	componentWillUnmount() {
		document.removeEventListener('mousedown', this._checkForOutsideClick, false);
		document.removeEventListener('touchstart', this._checkForOutsideClick, false);

		if (this.props.subscribeTo) {
			models[this.props.subscribeTo].unsubscribe(this.subId);
		}
	}

	componentWillReceiveProps = (nextProps) => {
		if (nextProps.value !== this.state.value && nextProps.value !== undefined) {
			let search = this.state.search;
			if (this.state.options) {
				search = this.getSearch(this.state.options[nextProps.value], nextProps.displayFields, this.state.values);
			}
			this.setState({ value: nextProps.value, search });
		}
	};

	_setOptions = async () => {
		let options = await this._getOptionsFromUrl();
		if (!options) options = this._getOptionsFromModel();
		if (options) {
			options = this._formatOptions(options);
			let search = this.getSearch(options[this.state.value], this.props.displayFields, this.state.values);
			this.setState({ options, filteredOptions: options, search });
		}
	};

	_checkForOutsideClick = (e) => {
		if (!this.element.contains(e.target)) {
			if (this.state.open) this._applyFilter();
		}
	};

	isValid = () => {
		let hasValue = false;
		if (this.state) {
			hasValue = !this._isEmpty(this.state.value);
		}
		let required = this.props.required;
		if (required && hasValue) {
			return true;
		} else if (!required) {
			return true;
		} else {
			this.setState({ valid: false });
			return false;
		}
	};

	_defaultValue = () => {
		if (this._isEmpty(this.props.value)) {
			return -1;
		}
		return this.props.value;
	};

	_isEmpty = (value) => {
		if (value === null) return true;
		if (value === undefined) return true;
		if (value === '') return true;
		if (value === -1) return true;
		return false;
	};

	_getOptionsFromUrl = async () => {
		if (this.props.src) {
			let table = this.props.src.split('-')[0];
			let column = this.props.src.split('-')[1];
			let options = await mainAPI.enum.get({ table, column });

			return options;
		} else if (this.props.endpoint) {
			let options = await this.props.endpoint();

			return options;
		}
	};

	_getOptionsFromModel = () => {
		if (!this.props.model) return;
		return models[this.props.model].objs();
	};

	_getDisplayValue = (value) => {
		let displayValue = '';
		let label = this.props.label;
		if (label) {
			if (Array.isArray(label)) {
				for (let i in label) {
					displayValue += value[label[i]] + ' ';
				}
			} else {
				displayValue = value[label];
			}
		} else {
			displayValue = value.name;
		}
		return displayValue;
	};

	_addSearchValue = (option) => {
		for (let i in this.props.displayFields) {
			option._search_value += ' ' + option[this.props.displayFields[i]];
		}
		return option;
	};

	_formatOptions = (options) => {
		if (!this.props.displayFields) return options;
		for (let i in options) {
			options[i] = this._addSearchValue(options[i]);
		}
		return options;
	};

	getValue = () => {
		return this.state.value;
	};

	onChange = (value, dontRemove) => {
		let state = {};
		let values = this.state.values || {};
		values[value] = dontRemove;
		if (!values[value]) {
			delete values[value];
		} else {
			state.value = value;
		}
		if (value === -1) {
			if (dontRemove) {
				values = { '-1': true };
				state.open = false;
				this.props.onChange(-1, '', false, null);
			}
		} else {
			delete values[-1];
		}
		state.values = values;
		this.getSearch(this.state.options[firstValue(values)], this.props.displayFields, values);
		// state.search = search;
		// let filteredOptions = this._filteredOptions(search);
		// state.filteredOptions = filteredOptions;
		this.setState(state);
	};

	_renderInvalidText = () => {
		if (!this.state.valid) {
			return <Validation />;
		}
	};

	_toggleOpen = () => {
		this._setOptions();
		let open = !this.state.open;
		if (open) return this._showOptions();
		let search = this.state.search;
		if (this.state.options) {
			search = this.getSearch(this.state.options[this.state.value]);
		}
		this.setState({ open: false, search });
	};

	_classes = () => {
		let classes = 'g-drop-down-select-many  ' + (this.props.className || '');
		if (this.state.open) classes += ' open ';
		return classes;
	};

	_showOptions = () => {
		if (this.state.open) return;
		let filteredOptions = this._filteredOptions('');
		this.setState({ open: true, search: '', filteredOptions });
	};

	_handleSearchChange = (value) => {
		let filteredOptions = this._filteredOptions(value);
		this.setState({ filteredOptions, search: value, open: true });
	};

	_filteredOptions = (value) => {
		if (!value) return this.state.options;
		let filteredOptions = fuzzysort.go(value, objUtils.to_array(this.state.options), { key: '_search_value' });
		let returnOptions = {};
		for (let i in filteredOptions) {
			let option = filteredOptions[i];
			if (!option || !option.obj) continue;
			returnOptions[option.obj.id] = option.obj;
		}
		return returnOptions;
	};

	_renderSelected = () => {
		return (
			<Label black-light autosize className="input-placeholder">
				{this.state.search || this.props.placeholder}
			</Label>
		);
	};

	_renderOptions = () => {
		let opt = [];

		for (let i in this.state.filteredOptions) {
			let val = this.state.filteredOptions[i];
			let display = displayValue(val, this.props.displayFields);
			let key = i;
			if (val && val.id) {
				key = val.id;
			}
			if (val && val.name) display = val.name;
			let isSelected = this.state.values[i];
			opt.push(this._addOption(key, isSelected, display));
		}
		let input = null;
		if (!this.props.noSearch) {
			input = (
				<Input
					iconName="icon-search"
					value={this.state.search}
					onChange={this._handleSearchChange}
					placeholder="Search"
				/>
			);
		}
		return (
			<div className="options">
				{input}
				<div className="option-scroll-container">{opt}</div>
				<Divider />
				{this._saveAndClearOptions()}
			</div>
		);
	};

	_saveAndClearOptions = () => {
		const otherProps = {}
		if(this.state.open){
			otherProps.tabIndex = "0";
		}
		return (
			<div className="save-and-clear">
				<Label 
					{...otherProps}
					blue
					bold
					medium-small
					onClick={() => {
						this.onChange(-1, true);
					}}
				>
					Clear Filters
				</Label>
				<PrimaryButton onClick={this._applyFilter}>Apply</PrimaryButton>
			</div>
		);
	};

	_applyFilter = () => {
		let search = this.getSearch(
			this.state.options[firstValue(this.state.values)],
			this.props.displayFields,
			this.state.values
		);
		this.props.onChange(-1, search, false, null);
		for (let i in this.state.values) {
			if (this.props.onChange) {
				setTimeout(() => {
					this.props.onChange(i, search, false, this.state.options[i].value);
				}, 100);
			}
		}
		this.setState({ open: false, search });
	};

	_addOption = (key, isSelected, display) => {
		const otherProps = {}
		if(this.state.open){
			otherProps.tabIndex = "0";
		}
		return (
			<div key={key}>
				<CheckBox
					{...otherProps}
					value={!!isSelected}
					onChange={(value) => {
						this.onChange(key, value);
					}}
				/>
				<Label black-light medium-small>
					{' '}
					{display}
				</Label>
			</div>
		);
	};

	getSearch = (search, displayFields, values) => {
		if (values && objUtils.length(values) > 1) {
			return showManySelected(this.props.plural, values);
		}
		if (!search) return '';
		if (!displayFields) return search.name || search;
		let ret = [];
		for (let i in displayFields) {
			ret.push(search[displayFields[i]]);
		}
		return ret.join(' ');
	};

	render() {
		return (
			<div tabIndex="0" ref={(ref) => (this.element = ref)} className={this._classes()} onClick={this._showOptions}>
				{this._renderSelected()}
				{this._renderOptions()}
				<FontIcon name="icon-chevron-right" />
				{this._renderInvalidText()}
			</div>
		);
	}
}

let showManySelected = (plural, values) => {
	let ct = 0;
	// eslint-disable-next-line no-unused-vars
	for (let i in values) {
		ct++;
	}
	return ct + ' ' + plural;
};

let displayValue = (object, displayFields) => {
	if (!object) return null;
	if (!displayFields) displayFields = ['name'];
	let name = [];
	for (let i in displayFields) {
		name.push(object[displayFields[i]]);
	}
	return name.join(' ');
};

let firstValue = (obj) => {
	for (let i in obj) {
		return i;
	}
	return null;
};



// WEBPACK FOOTER //
// ./src/components/dropDownSelectMany/DropDownSelectMany.jsx